import React from "react";
import { useHistory } from "react-router-dom";
import DialogCommon from "../../../../components/dialogCommon";
import * as S from "./styles";

interface ModalDetalheVisitaProps {
  open: boolean;
  onClose: () => void;
  visita: any;
}

const ModalDetalheVisita: React.FC<ModalDetalheVisitaProps> = ({
  open,
  onClose,
  visita,
}) => {
  const history = useHistory();

  const canNavigateToLead =
    visita?.podeVisualizar !== false && visita?.idLeadCorretor;

  const handleGoToLead = () => {
    if (canNavigateToLead) {
      history.push(`/lead-detail/${visita.idLeadCorretor}`);
      onClose();
    }
  };

  if (!visita) return null;

  return (
    <DialogCommon
      open={open}
      setOpenModal={(value: boolean) => {
        if (!value) onClose();
      }}
      onClose={onClose}
      onSave={() => console.log("salvar")}
      isFilter={false}
      width={900}
      titleHeader="Detalhe Visita"
      component={
        <S.Content>
          {/* Linha 1: Empreendimento | Data da Visita */}
          <S.Row template="1fr 1fr">
            <S.Field>
              <S.Label>Empreendimento</S.Label>
              <S.Value>{visita.empreendimento || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Data da visita</S.Label>
              <S.Value>{visita.dataVisita || "-"}</S.Value>
            </S.Field>
          </S.Row>

          {/* Linha 2: Tipo de Atendimento | Origem | Canal */}
          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <S.Label>Tipo de atendimento</S.Label>
              <S.Value>{visita.tipoAtendimento || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Origem</S.Label>
              <S.Value>{visita.origem || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Canal</S.Label>
              <S.Value>{visita.canalContato || "-"}</S.Value>
            </S.Field>
          </S.Row>

          {/* Linha 3: Corretor Origem | Corretor Atendimento */}
          <S.Row template="1fr 1fr">
            <S.Field>
              <S.Label>Corretor Origem</S.Label>
              <S.Value>{visita.corretorOrigem || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Corretor Atendimento</S.Label>
              <S.Value>{visita.corretorAtendimento || "-"}</S.Value>
            </S.Field>
          </S.Row>

          {/* Linha 4: Nome | Email | Telefone */}
          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <S.Label>Nome</S.Label>
              <S.Value>{visita.nome || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Email</S.Label>
              <S.Value>{visita.email || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Telefone</S.Label>
              <S.Value>{visita.telefone || "-"}</S.Value>
            </S.Field>
          </S.Row>

          {/* Linha 5: CEP | Bairro Residencial | Bairro Comercial */}
          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <S.Label>CEP</S.Label>
              <S.Value>{visita.cep || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Bairro Residencial</S.Label>
              <S.Value>{visita.bairro || "-"}</S.Value>
            </S.Field>
            <S.Field>
              <S.Label>Bairro Comercial</S.Label>
              <S.Value>{visita.bairroComercial || "-"}</S.Value>
            </S.Field>
          </S.Row>

          <S.ButtonContainer>
            <S.Button
              onClick={handleGoToLead}
              disabled={!canNavigateToLead}
              style={{
                opacity: canNavigateToLead ? 1 : 0.5,
                cursor: canNavigateToLead ? "pointer" : "not-allowed",
              }}
            >
              Acessar Informações Gerais do Lead
            </S.Button>
          </S.ButtonContainer>
        </S.Content>
      }
    />
  );
};

export default ModalDetalheVisita;
